<template>
  <div>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'MainPress'
}
</script>

<style lang="scss" scoped>

</style>
